// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"64f4efcf","732":"ce9ef997","977":"9b36e996"}[chunkId] + ".chunk.js";
};